import React from 'react';
import PropTypes from 'prop-types';
import InputSelectMobile from './input-select-mobile';
import InputSelectDesktop from './input-select-desktop';
import InputSelectDropdown from './input-dropdown';
import { css } from 'emotion';
import styles from './input-select.module.css';
import globalStyles from '../../form.module.css';

class InputSelect extends React.Component {
  constructor() {
    super();
    this.state = {
      select: false,
    };
  }

  updateSelectData = selectValue => {
    this.props.captureSelectData(selectValue);
  };

  toggleSelect = event => {
    this.setState(prevState => ({
      select: !prevState.select,
    }));
  };

  renderMobileSelect = () => {
    return (
      <InputSelectMobile
        value={this.props.value}
        options={this.props.options}
        select={this.state.select}
        captureSelectData={this.props.captureSelectData}
      />
    );
  };

  renderDesktopSelect = () => {
    return (
      <InputSelectDesktop
        value={this.props.value}
        theme={this.props.theme}
        toggleSelect={this.toggleSelect}
      />
    );
  };

  render() {
    const { browserDetect } = this.props;

    return (
      <React.Fragment>
        <div className={styles.wrapper}>
          {browserDetect === 'iOS' || browserDetect === 'iPad' ? (
            <div className={styles.iosSelect}>{this.renderMobileSelect()}</div>
          ) : (
            <React.Fragment>
              <div className={styles.mobileSelector}>
                {this.renderMobileSelect()}
              </div>
              <div className={styles.desktopSelector}>
                {this.renderDesktopSelect()}
              </div>
            </React.Fragment>
          )}
          {this.state.select && (
            <InputSelectDropdown
              placeholder={this.props.value}
              options={this.props.options}
              toggleSelect={this.toggleSelect}
              updateSelectData={this.updateSelectData}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default InputSelect;

InputSelect.propTypes = {
  options: PropTypes.array,
  value: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/form/inputs/input-select/index.js